/**
 * Mapeo de provincias y distritos para elecciones
 */

export const mappings = {
  // Provincias argentinas
  provinces: {
    "01": {
      id: "01",
      name: "Ciudad de Buenos Aires",
      code: "AR-C",
      shortName: "CABA",
      hasGovernor: true,
      isAutonomous: true
    },
    "02": {
      id: "02",
      name: "Buenos Aires",
      code: "AR-B",
      shortName: "Buenos Aires",
      hasGovernor: true,
      isAutonomous: false
    },
    "03": {
      id: "03",
      name: "Catamarca",
      code: "AR-K",
      shortName: "Catamarca",
      hasGovernor: true,
      isAutonomous: false
    },
    "04": {
      id: "04",
      name: "Córdoba",
      code: "AR-X",
      shortName: "Córdoba",
      hasGovernor: true,
      isAutonomous: false
    },
    "05": {
      id: "05",
      name: "Corrientes",
      code: "AR-W",
      shortName: "Corrientes",
      hasGovernor: true,
      isAutonomous: false
    },
    "06": {
      id: "06",
      name: "Chaco",
      code: "AR-H",
      shortName: "Chaco",
      hasGovernor: true,
      isAutonomous: false
    },
    "07": {
      id: "07",
      name: "Chubut",
      code: "AR-U",
      shortName: "Chubut",
      hasGovernor: true,
      isAutonomous: false
    },
    "08": {
      id: "08",
      name: "Entre Ríos",
      code: "AR-E",
      shortName: "Entre Ríos",
      hasGovernor: true,
      isAutonomous: false
    },
    "09": {
      id: "09",
      name: "Formosa",
      code: "AR-P",
      shortName: "Formosa",
      hasGovernor: true,
      isAutonomous: false
    },
    "10": {
      id: "10",
      name: "Jujuy",
      code: "AR-Y",
      shortName: "Jujuy",
      hasGovernor: true,
      isAutonomous: false
    },
    "11": {
      id: "11",
      name: "La Pampa",
      code: "AR-L",
      shortName: "La Pampa",
      hasGovernor: true,
      isAutonomous: false
    },
    "12": {
      id: "12",
      name: "La Rioja",
      code: "AR-F",
      shortName: "La Rioja",
      hasGovernor: true,
      isAutonomous: false
    },
    "13": {
      id: "13",
      name: "Mendoza",
      code: "AR-M",
      shortName: "Mendoza",
      hasGovernor: true,
      isAutonomous: false
    },
    "14": {
      id: "14",
      name: "Misiones",
      code: "AR-N",
      shortName: "Misiones",
      hasGovernor: true,
      isAutonomous: false
    },
    "15": {
      id: "15",
      name: "Neuquén",
      code: "AR-Q",
      shortName: "Neuquén",
      hasGovernor: true,
      isAutonomous: false
    },
    "16": {
      id: "16",
      name: "Río Negro",
      code: "AR-R",
      shortName: "Río Negro",
      hasGovernor: true,
      isAutonomous: false
    },
    "17": {
      id: "17",
      name: "Salta",
      code: "AR-A",
      shortName: "Salta",
      hasGovernor: true,
      isAutonomous: false
    },
    "18": {
      id: "18",
      name: "San Juan",
      code: "AR-J",
      shortName: "San Juan",
      hasGovernor: true,
      isAutonomous: false
    },
    "19": {
      id: "19",
      name: "San Luis",
      code: "AR-D",
      shortName: "San Luis",
      hasGovernor: true,
      isAutonomous: false
    },
    "20": {
      id: "20",
      name: "Santa Cruz",
      code: "AR-Z",
      shortName: "Santa Cruz",
      hasGovernor: true,
      isAutonomous: false
    },
    "21": {
      id: "21",
      name: "Santa Fe",
      code: "AR-S",
      shortName: "Santa Fe",
      hasGovernor: true,
      isAutonomous: false
    },
    "22": {
      id: "22",
      name: "Santiago del Estero",
      code: "AR-G",
      shortName: "Santiago del Estero",
      hasGovernor: true,
      isAutonomous: false
    },
    "23": {
      id: "23",
      name: "Tierra del Fuego",
      code: "AR-V",
      shortName: "Tierra del Fuego",
      hasGovernor: true,
      isAutonomous: false
    },
    "24": {
      id: "24",
      name: "Tucumán",
      code: "AR-T",
      shortName: "Tucumán",
      hasGovernor: true,
      isAutonomous: false
    }
  },

  // Distritos por provincia (ejemplo para CABA - Comunas)
  districts: {
    "01": [ // Ciudad de Buenos Aires - Comunas
      {
        id: "001",
        name: "Comuna 1",
        code: "AR-C001",
        provinceId: "01",
        barrios: ["Retiro", "San Nicolás", "Puerto Madero", "San Telmo", "Monserrat", "Constitución"]
      },
      {
        id: "002",
        name: "Comuna 2",
        code: "AR-C002",
        provinceId: "01",
        barrios: ["Recoleta"]
      },
      {
        id: "003",
        name: "Comuna 3",
        code: "AR-C003",
        provinceId: "01",
        barrios: ["Balvanera", "San Cristóbal"]
      },
      {
        id: "004",
        name: "Comuna 4",
        code: "AR-C004",
        provinceId: "01",
        barrios: ["La Boca", "Barracas", "Parque Patricios", "Nueva Pompeya"]
      },
      {
        id: "005",
        name: "Comuna 5",
        code: "AR-C005",
        provinceId: "01",
        barrios: ["Almagro", "Boedo"]
      },
      {
        id: "006",
        name: "Comuna 6",
        code: "AR-C006",
        provinceId: "01",
        barrios: ["Caballito"]
      },
      {
        id: "007",
        name: "Comuna 7",
        code: "AR-C007",
        provinceId: "01",
        barrios: ["Flores", "Parque Chacabuco"]
      },
      {
        id: "008",
        name: "Comuna 8",
        code: "AR-C008",
        provinceId: "01",
        barrios: ["Villa Soldati", "Villa Lugano", "Villa Riachuelo"]
      },
      {
        id: "009",
        name: "Comuna 9",
        code: "AR-C009",
        provinceId: "01",
        barrios: ["Liniers", "Mataderos", "Parque Avellaneda"]
      },
      {
        id: "010",
        name: "Comuna 10",
        code: "AR-C010",
        provinceId: "01",
        barrios: ["Villa Real", "Monte Castro", "Versalles", "Floresta", "Vélez Sársfield", "Villa Luro"]
      },
      {
        id: "011",
        name: "Comuna 11",
        code: "AR-C011",
        provinceId: "01",
        barrios: ["Villa General Mitre", "Villa Devoto", "Villa del Parque", "Villa Santa Rita"]
      },
      {
        id: "012",
        name: "Comuna 12",
        code: "AR-C012",
        provinceId: "01",
        barrios: ["Coghlan", "Saavedra", "Villa Urquiza", "Villa Pueyrredón"]
      },
      {
        id: "013",
        name: "Comuna 13",
        code: "AR-C013",
        provinceId: "01",
        barrios: ["Núñez", "Belgrano", "Colegiales"]
      },
      {
        id: "014",
        name: "Comuna 14",
        code: "AR-C014",
        provinceId: "01",
        barrios: ["Palermo"]
      },
      {
        id: "015",
        name: "Comuna 15",
        code: "AR-C015",
        provinceId: "01",
        barrios: ["Chacarita", "Villa Crespo", "La Paternal", "Villa Ortúzar", "Agronomía", "Parque Chas"]
      }
    ],
    // Distritos de Buenos Aires (ejemplo: algunos partidos principales)
    "02": [
      {
        id: "001",
        name: "La Plata",
        code: "AR-B001",
        provinceId: "02"
      },
      {
        id: "002",
        name: "La Matanza",
        code: "AR-B002",
        provinceId: "02"
      },
      {
        id: "003",
        name: "Avellaneda",
        code: "AR-B003",
        provinceId: "02"
      },
      {
        id: "004",
        name: "Quilmes",
        code: "AR-B004",
        provinceId: "02"
      },
      {
        id: "005",
        name: "Lomas de Zamora",
        code: "AR-B005",
        provinceId: "02"
      },
      {
        id: "006",
        name: "San Isidro",
        code: "AR-B006",
        provinceId: "02"
      },
      {
        id: "007",
        name: "Vicente López",
        code: "AR-B007",
        provinceId: "02"
      },
      {
        id: "008",
        name: "San Miguel",
        code: "AR-B008",
        provinceId: "02"
      },
      {
        id: "009",
        name: "Tigre",
        code: "AR-B009",
        provinceId: "02"
      },
      {
        id: "010",
        name: "Morón",
        code: "AR-B010",
        provinceId: "02"
      }
    ],
    // Catamarca - Departamentos principales
    "03": [
      {
        id: "001",
        name: "Capital",
        code: "AR-K001",
        provinceId: "03"
      },
      {
        id: "002",
        name: "Valle Viejo",
        code: "AR-K002",
        provinceId: "03"
      },
      {
        id: "003",
        name: "Fray Mamerto Esquiú",
        code: "AR-K003",
        provinceId: "03"
      }
    ]
  },

  // Partidos políticos principales
  parties: {
    "UP": {
      id: "UP",
      name: "Unión por la Patria",
      shortName: "UP",
      color: "#00AEEF"
    },
    "JXC": {
      id: "JXC",
      name: "Juntos por el Cambio",
      shortName: "JxC",
      color: "#FFD100"
    },
    "LLA": {
      id: "LLA",
      name: "La Libertad Avanza",
      shortName: "LLA",
      color: "#6F2C91"
    },
    "HNP": {
      id: "HNP",
      name: "Hacemos por Nuestro País",
      shortName: "HNP",
      color: "#00A859"
    },
    "FIT": {
      id: "FIT",
      name: "Frente de Izquierda y de Trabajadores",
      shortName: "FIT-U",
      color: "#DC143C"
    }
  },

  // Tipos de elección soportados
  electionTypes: {
    "presidente": {
      name: "Presidente",
      requiresSecondRound: true,
      threshold: 45,
      alternativeThreshold: { percent: 40, difference: 10 }
    },
    "gobernador": {
      name: "Gobernador",
      requiresSecondRound: false
    },
    "jefeGobierno": {
      name: "Jefe de Gobierno",
      requiresSecondRound: false
    },
    "legislativas": {
      name: "Legislativas",
      requiresSecondRound: false
    },
    "delegados": {
      name: "Delegados Comunales",
      requiresSecondRound: false
    },
    "senadores": {
      name: "Senadores",
      requiresSecondRound: false
    },
    "diputados": {
      name: "Diputados",
      requiresSecondRound: false
    },
    "concejales": {
      name: "Concejales",
      requiresSecondRound: false
    },
    "intendentes": {
      name: "Intendentes",
      requiresSecondRound: false
    }
  }
};

/**
 * Obtener provincia por código
 */
export const getProvinceByCode = (code) => {
  return Object.values(mappings.provinces).find(p => p.code === code);
};

/**
 * Obtener distritos de una provincia
 */
export const getDistrictsByProvince = (provinceId) => {
  return mappings.districts[provinceId] || [];
};

/**
 * Obtener distrito por código
 */
export const getDistrictByCode = (code) => {
  for (const districts of Object.values(mappings.districts)) {
    const district = districts.find(d => d.code === code);
    if (district) return district;
  }
  return null;
};

/**
 * Verificar si una provincia tiene elecciones
 */
export const hasElections = (provinceCode, electionType) => {
  const province = getProvinceByCode(provinceCode);
  if (!province) return false;

  if (electionType === 'gobernador') {
    return province.hasGovernor;
  }

  return true;
};